import en from './en.json';
import fa from './fa.json';
import fr from './fr.json';
import es from './es.json';
import ru from './ru.json';
import de from './de.json';

export default { en, fa, fr, es, ru, de };
